import { render } from "./SectionPress.vue?vue&type=template&id=081cb64e&scoped=true"
import script from "./SectionPress.vue?vue&type=script&lang=js"
export * from "./SectionPress.vue?vue&type=script&lang=js"

import "./SectionPress.vue?vue&type=style&index=0&id=081cb64e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-081cb64e"]])

export default __exports__